import {createCrud} from "./CRUD";

const initialState = { items: [], item: {} };

let {constants, actions, reducer} =
    createCrud(
        '/main/ranking-statuses/',
        'RankingStatus',
        'RankingStatuses',
        initialState);

export const rankingStatusConstants = constants;
export const rankingStatusActions = actions;
export const rankingStatusReducer = reducer;
